import { render, staticRenderFns } from "./CorrelationChart.vue?vue&type=template&id=1861ba56&scoped=true"
import script from "./CorrelationChart.vue?vue&type=script&lang=js"
export * from "./CorrelationChart.vue?vue&type=script&lang=js"
import style0 from "./CorrelationChart.vue?vue&type=style&index=0&id=1861ba56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1861ba56",
  null
  
)

export default component.exports